// extracted by mini-css-extract-plugin
module.exports = {"option":"Option_option__G8WnK","optionContent":"Option_optionContent__rLp4G","selectedOption":"Option_selectedOption__dJF4u"};